var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgYellowLineNew = function SvgYellowLineNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.847c11.29-.89 42.45-2.536 86.67-2.968 35.624-.348 79.724.092 128.74 2.35",
    stroke: "#F9D24B",
    strokeWidth: 3.733,
    strokeLinecap: "round"
  })));
};
export default SvgYellowLineNew;